export default [
  {
    id: "I",
    title: "Mechanical equipment located within the occupied space",
    description:
      "If all the refrigerating system or refrigerant-containing parts are located in the occupied space, then the system is considered to be location Class I. If only part of the system is inside the occupied space and the compressors and pressure vessels are located in a machinery room (compliant with the requirements of EN 378-3) or in the open air, the system is location Class II."
  },
  {
    id: "II",
    title: "Compressors in machinery room or open air",
    description:
      "If part of the refrigerating system is inside the occupied space e.g. coils and pipework including valves, but all the compressors and pressure vessels are either located in a machinery room (compliant with the requirements of EN 378-3) or in the open air, then the location is Class II. If all the refrigerant-containing parts are located in a machinery room (compliant with the requirements of EN 378-3) or the open air, the system is location Class III."
  },
  {
    id: "III",
    title: "Machinery room or open air",
    description:
      "If all refrigerant-containing parts are located in a machinery room (compliant with the requirements of EN 378-3) or open air then the location is class III."
  },
  {
    id: "IV",
    title: "Ventilated enclosure",
    description:
      "If all refrigerant-containing parts are located in a ventilated enclosure (compliant with the requirements of EN 378-2 and EN 378-3) which prevents refrigerants entering the occupied space, then the location is class IV."
  }
];
